import React, { useState,useEffect} from 'react';  
import ReactQuill from 'react-quill';  
import 'react-quill/dist/quill.snow.css';  
import './Broadcast.css';
import {
  createTeamsPayload,
  createTeamsPayloadWithAdaptiveCard,
  convertQuillToAdaptiveCardText,
  extractPlainText
} from './teamsFormatter.js';  
 
export default function Broadcast() {  
  const [text, setText] = useState('');  
  const [type, setType] = useState('msg');  
  const [subject, setSubject] = useState('');  
  const [sendTo, setSendTo] = useState('');  
  const [savedContent, setSavedContent] = useState([]);  
  const [error, setError] = useState({ text: false, message: '' });  
  const [validatedEmails, setValidatedEmails] = useState({ validEmails: [], invalidEmails: [] });
  
   useEffect(() => {
    const tooltips = [
      { selector: ".ql-header[value='1']", title: "Heading 1" },
      { selector: ".ql-header[value='2']", title: "Heading 2" },
      { selector: ".ql-header:not([value])", title: "Normal Text" },
      { selector: ".ql-bold", title: "Bold (Ctrl + B)" },
      { selector: ".ql-italic", title: "Italic (Ctrl + I)" },
      { selector: ".ql-underline", title: "Underline (Ctrl + U)" },
      { selector: ".ql-strike", title: "Strikethrough" },
      { selector: ".ql-color", title: "Text Color" },
      { selector: ".ql-background", title: "Highlight Color" },
      { selector: ".ql-list[value='ordered']", title: "Numbered List" },
      { selector: ".ql-list[value='bullet']", title: "Bullet List" },
      { selector: ".ql-indent[value='-1']", title: "Decrease Indent" },
      { selector: ".ql-indent[value='+1']", title: "Increase Indent" },
      { selector: ".ql-blockquote", title: "Blockquote" },
      { selector: ".ql-link", title: "Insert/Edit Link" }
    ];

    // Apply tooltips
    tooltips.forEach(({ selector, title }) => {
      const element = document.querySelector(selector);
      if (element) element.setAttribute("title", title);
    });
  }, []);
 
  const defaultTemplate = [  
    { title: 'Details', content: '' },  
    { title: 'Impact', content: '' },  
    { title: 'Action required', content: '' },  
    { title: 'Distribution', content: '' },  
    { title: 'Schedule', content: '' },  
    { title: 'On FastTrack', content: '' },  
  ];  
  const [templateContent, setTemplateContent] = useState([...defaultTemplate]);  
 
  async function validateEmails() {  
    const emailList = sendTo.split(';').map(email => email.trim());  
    try {  
      const response = await fetch('/api/validate-emails', {  
        method: 'POST',  
        headers: { 'Content-Type': 'application/json' },  
        body: JSON.stringify({ emails: emailList })  
      });  
 
      if (!response.ok) {  
        throw new Error('Failed to validate emails');  
      }  
 
      const data = await response.json();  
      setValidatedEmails(data);  
    } catch (error) {  
      console.error('Error validating emails:', error);  
      setValidatedEmails({ validEmails: [], invalidEmails: [] });  
      setError({ text: true, message: 'Error validating emails' });  
    }  
  }  
 
  function handleTypeChange(event) {  
    const newType = event.target.value;  
    setType(newType);  
    if (newType === 'table') {  
      setTemplateContent([...defaultTemplate]);
      setText(''); // Clear message content when switching to table
    } else {
      // Clear table content when switching to message
      setTemplateContent([...defaultTemplate]);
    }  
  }  
 
  function handleTemplateChange(index, content) {  
    const updatedTemplate = [...templateContent];  
    updatedTemplate[index].content = content;  
    setTemplateContent(updatedTemplate);  
  }  
 
  function handleSubjectChange(event) {  
    setSubject(event.target.value);  
  }  
 
  function handleSendToChange(event) {  
    setSendTo(event.target.value);  
  }  
 
  function handleQuillChange(content) {  
    setText(content);  
  }  
 
  function clearMessage() {  
    setText('');  
    setType('msg');  
    setSubject('');  
    setSendTo('');  
    setTemplateContent([...defaultTemplate]);  
    setSavedContent([]);  
    setError({ text: false, message: '' });  
    setValidatedEmails({ validEmails: [], invalidEmails: [] });  
  }  
 
  async function validateFields() {  
    if (!subject.trim()) {  
      setError({ text: true, message: 'Subject is required!' });  
      return false;  
    }  
    if (!sendTo.trim()) {  
      setError({ text: true, message: 'Please enter email addresses!' });  
      return false;  
    }  
   
    // Only validate message content for 'msg' type
    if (type === 'msg') {  
      if (!text.trim()) {  
        setError({ text: true, message: 'Text content is required!' });  
        return false;  
      }  
    }
    // For 'table' type, fields are optional - no validation needed
   
    setError({ text: false, message: '' });  
    return true;  
  }  
 
  async function saveMessage() {  
    const check = await validateFields();  
    if (!check) {  
      return;  
    }
 
    let teamsPayload;
   
    if (type === 'msg') {
      // For message type: Send Activity with HTML formatting
      const basePayload = createTeamsPayload(
        subject,
        text,
        sendTo,
        [], // attachments
        []  // optionalEditors
      );
     
      teamsPayload = {
        ...basePayload,
        type: 'msg'
      };
    } else {
      // For table type: Convert HTML to Markdown for Adaptive Card
      // Filter out empty fields
      const filteredContent = templateContent
        .filter(item => item.content.trim())
        .map(item => ({
          title: item.title,
          content: convertQuillToAdaptiveCardText(item.content)
        }));
 
      teamsPayload = {
        sendTo: sendTo.split(';').map(email => email.trim()).filter(Boolean),
        subject,
        type: 'table',
        content: filteredContent,
        timestamp: new Date().toISOString()
      };
    }
 
    setSavedContent([teamsPayload]);
    console.log('Message saved:', teamsPayload);
  }  
 
  async function handleSubmit(event) {  
    event.preventDefault();  
    const check = await validateFields();  
    if (!check) {  
      return;  
    }  
 
    await validateEmails();  
   
    let teamsPayload;
   
    if (type === 'msg') {
      // For message type: Send Activity with HTML formatting
      const basePayload = createTeamsPayload(
        subject,
        text,
        sendTo,
        [], // attachments - add if you have image uploads
        []  // optionalEditors - add if you have popup/link editors
      );
     
      teamsPayload = {
        ...basePayload,
        type: 'msg'
      };
    } 
    else if (type === 'table') {
  // Filter out empty editors properly
  const filteredContent = templateContent
    .filter(item => {
      const cleaned = item.content
        .replace(/<p><br><\/p>/g, '')
        .replace(/<[^>]*>/g, '')
        .trim();
      return cleaned !== '';
    })
    .map(item => ({
      title: item.title,
      content: convertQuillToAdaptiveCardText(item.content)
    }));

  teamsPayload = {
    sendTo: sendTo.split(';').map(email => email.trim()).filter(Boolean),
    subject,
    type: 'table',
    content: filteredContent,
    timestamp: new Date().toISOString()
  };
}
    else {
      // For table type: Convert HTML to Markdown for Adaptive Card
      // Filter out empty fields
      const filteredContent = templateContent
        .filter(item => item.content.trim())
        .map(item => ({
          title: item.title,
          content: convertQuillToAdaptiveCardText(item.content)
        }));
 
      teamsPayload = {
        sendTo: sendTo.split(';').map(email => email.trim()).filter(Boolean),
        subject,
        type: 'table',
        content: filteredContent,
        timestamp: new Date().toISOString()
      };
    }
 
    console.log('Sending to Teams:', teamsPayload);
   
    try {  
      const response = await fetch(`/api/notification`, {  
        method: 'POST',  
        headers: {  
          'Content-Type': 'application/json',  
        },  
        body: JSON.stringify(teamsPayload),  
      });  
 
      if (!response.ok) {  
        throw new Error('Failed to send message');  
      }  
 
      console.log('Message sent to API successfully');
      setSavedContent([teamsPayload]);
      clearMessage();  
    } catch (error) {  
      console.error('Error sending message:', error);  
      setError({ text: true, message: error.message });  
    }  
  }  
 
  // Separate toolbar configuration for message type (Send Activity)
  // const messageModules = {
  //   toolbar: {
  //     container: [
  //       [{ 'header': [1, 2, false] }], // Headings 1, 2, 3
  //       ['bold', 'italic', 'strike'],     // Bold, Italic, Strikethrough
  //       [{ 'list': 'ordered' }, { 'list': 'bullet' }, { indent: '-1' }, { indent: '+1' }], // Lists with indent
  //       ['blockquote'],     // Blockquote
  //     ],
  //     handlers: {
  //       'custom-upload': handleFileUpload,
  //     },
  //   },
  // };
  const messageModules = {
  toolbar: {
    container: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['blockquote', 'link'],
    ],
    handlers: {
      'custom-upload': handleFileUpload,
    },
  },
};
  
  // Separate toolbar configuration for table type (Adaptive Cards)
  // Adaptive Cards support: bold, italic, bullet lists only
  const tableModules = {
    toolbar: {
      container: [
        ['bold', 'italic'],
        [{ 'list': 'bullet' }, { indent: '-1' }, { indent: '+1' },'link'],
      ],
    },
  };
 
  const formats = [
  'header', 'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'color', 'background', 'link',
];
 
  return (  
    <>  
      <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop:"20px" }}>Broadcast Dashboard</h1>  
      <div className="container">  
        <form className="section-container" onSubmit={handleSubmit}>  
          <label htmlFor="sendTo">Send To</label>  
          <input  
            type="text"  
            id="sendTo"  
            value={sendTo}  
            onChange={handleSendToChange}  
            placeholder="Enter email addresses separated by semicolon"  
          />  
          <div className="validatebutton">  
            <button type="button" onClick={validateEmails}>Validate Emails</button>  
            {validatedEmails.invalidEmails.length === 0 && validatedEmails.validEmails.length > 0 && (  
              <span style={{ marginLeft: '10px', color: 'green' }}>✅</span>  
            )}  
          </div>  
          <div className="validated-emails">  
            {validatedEmails.invalidEmails.map(email => (  
              <span  
                key={email}  
                style={{  
                  display: 'block',  
                  padding: '5px',  
                  backgroundColor: 'white',  
                  color: 'red'  
                }}  
              >  
                {email}  
              </span>  
            ))}  
          </div>  
 
          <div className="subject-sendto-container">  
            <div className="subject-container">  
              <label htmlFor="subject">Subject</label>  
              <input  
                type="text"  
                id="subject"  
                value={subject}  
                onChange={handleSubjectChange}  
                placeholder="Enter your subject"  
              />  
            </div>  
 
            <div className="send-to-container">  
              <label htmlFor="type">Type</label>  
              <select id="type" value={type} onChange={handleTypeChange}>  
                <option value="msg">Message (Send Activity)</option>  
                <option value="table">Table (Adaptive Card)</option>  
              </select>  
            </div>  
          </div>  
 
          {type === 'table' ? (  
            // Table mode: Multiple editors for Adaptive Cards (all optional)
            <div>
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                Fill in the fields you want to include (all fields are optional):
              </p>
              {templateContent.map((item, index) => (  
                <div key={index} className="template-row">  
                  <label>{item.title}</label>  
                  <ReactQuill  
                    className="react-quill"  
                    value={item.content}  
                    onChange={(content) => handleTemplateChange(index, content)}  
                    modules={tableModules}  
                    formats={formats}  
                    placeholder={`Enter ${item.title.toLowerCase()} content...`}
                  />  
                </div>  
              ))}
            </div>
          ) : (  
            // Message mode: Single editor for Send Activity
            <div>
              <label>Message Content</label>
              <ReactQuill  
                className="react-quill"  
                value={text}  
                onChange={handleQuillChange}  
                modules={messageModules}  
                formats={formats}  
                placeholder="Enter your message content..."
              />  
            </div>
          )}  
 
          {error.text && <p className="error-message">{error.message}</p>}  
 
          <div className="button-container">  
            <button type="button" className="save" onClick={saveMessage}>  
              Save  
            </button>  
            <button type="submit" className="publish">  
              Publish  
            </button>  
            <button type="button" onClick={clearMessage} className="button clear">  
              Clear  
            </button>  
          </div>  
 
          {savedContent.map((content, index) => (  
            <div key={index} className="saved-message">  
              <strong>Message Saved (Teams Format):</strong>  
              <pre>{JSON.stringify(content, null, 2)}</pre>  
            </div>  
          ))}  
        </form>  
        <footer></footer>  
      </div>  
    </>  
  );  
}  
 
// File upload handler for images in message mode
function handleFileUpload() {  
  const input = document.createElement('input');  
  input.setAttribute('type', 'file');  
  input.setAttribute('accept', 'image/*');  
  input.onchange = async () => {  
    const file = input.files[0];  
    if (file) {  
      try {  
        const url = await uploadFile(file);
        const quill = this.quill;
        const range = quill.getSelection();  
        quill.insertEmbed(range.index, 'image', url);  
      } catch (error) {  
        console.error('Error uploading file:', error);  
      }  
    }  
  };  
  input.click();  
}  
 
// Placeholder for file upload logic
async function uploadFile(file) {  
  // Implement your file upload logic here
  // Example: Upload to your server and return the URL
  return 'https://example.com/path/to/uploaded/file.jpg';  
}
 